import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "@environments/environment";
import { AuthService } from "@auth/interfaces/IAuthService";
import Keycloak from "keycloak-js";

export const LoggedGuard = () => {
    const keycloakService = inject(Keycloak);
    const authService = inject(AuthService);
    const router = inject(Router);

    const isLogged = authService.isLoggedIn();
    if (!isLogged) {
        keycloakService.login({
            redirectUri: environment.keycloak.redirectUrl + router.url,
        }).catch(e => console.error(e));
    }
    return isLogged;
};
